module.exports = __webpack_public_path__ + "static/media/adia_she.4e9f0186.jpg";